import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 13l3 -3l3 3","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-1"}]]

const IconCircleChevronUp = createReactComponent('outline', 'circle-chevron-up', 'CircleChevronUp', __iconNode);

export default IconCircleChevronUp;